const { default: axiosIns } = require('@/libs/axios')

const CampaignsAdGroups = {
  // GET - CampaignAdGroupsApiController
  async getCampaignsAdGroups(accountId) {
    return axiosIns.get(`/campaigns/adgroups?accountId=${accountId}`).then(response => response.data)
  },
  async getAdGroupMeta(adGroupId, adId, accountId) {
    return axiosIns.get(`/campaigns/adgroups/${adGroupId}/meta?accountId=${accountId}&adId=${adId}`).then(response => response.data)
  },
}

export default CampaignsAdGroups
